import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import type { FlagProps } from '../types';
import classes from '../flagpack.module.css';

export function FJFlag({ radius, className, size, ...others }: FlagProps) {
  return (
    <Box
      className={cx(classes.flag, className)}
      __vars={{ '--flag-radius': getRadius(radius), '--flag-size': rem(size) }}
      {...others}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 24">
        <defs>
          <mask id="mantine-1iboeyp4e" fill="#fff">
            <path fillRule="evenodd" d="M0 0h32v24H0z" />
          </mask>
          <mask id="mantine-m7n2k6bkv" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-ydvurfg9q" />
          </mask>
          <mask id="mantine-jdoqnii0j" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-2y5h2pbax" />
          </mask>
          <mask id="mantine-5h41yqe0m" fill="#fff">
            <use fillRule="evenodd" xlinkHref="#mantine-2tyk1104e" />
          </mask>
          <path id="mantine-ydvurfg9q" d="M0 0h32v24H0z" />
          <path
            id="mantine-2y5h2pbax"
            d="M0 0h9.655v8.333C9.115 10.778 7.506 12 4.828 12S.54 10.778 0 8.333z"
          />
          <path id="mantine-2tyk1104e" d="M0 0h18v14H0z" />
        </defs>
        <g fill="none" fillRule="evenodd" mask="url(#mantine-1iboeyp4e)">
          <use fill="#67bfe5" xlinkHref="#mantine-ydvurfg9q" />
          <g mask="url(#mantine-m7n2k6bkv)">
            <g transform="translate(20 10)">
              <use fill="#f7fcff" xlinkHref="#mantine-2y5h2pbax" />
              <g fill="#c3352c" mask="url(#mantine-jdoqnii0j)">
                <path d="M0 0h9.655v3H0z" />
                <path d="M4.138 2.667h1.38V12h-1.38z" />
                <path d="M0 6.333h9.655v1.334H0z" />
              </g>
              <g mask="url(#mantine-jdoqnii0j)">
                <path
                  fill="#979797"
                  fillRule="nonzero"
                  d="M3.929 11.394c-.335.484-.808.164-1.388-.657-.312-.414-.592-.639-.826-.686-.468-.094-1.349-.878-1.2-1.305.098-.281.249-.283.852-.208l.041.006c.21.026.286.034.356.034.06 0-.204.105.419-.158a2.29 2.29 0 011.021-.196l.186.355c.036.011.094.024.173.036l.082.013c.266.041.351.064.445.178.18.217.058.413-.215.622-.302.23-.348.315-.341.377.018.046.015.168-.08.259a.439.439 0 01-.01.01c.078.135.215.327.409.574.335.067.31.407.076.746zm-.593-1.258a.538.538 0 01-.14.013.26.26 0 00.152-.039zM.994 8.968C.982 8.954.978 8.935.987 8.91c-.002.005.004.016.016.032zm.009-.026c.098.13.62.58.81.619.379.076.75.373 1.132.882.388.548.57.671.572.667.076-.109.076.026.206.026l-.195-.094c-.272-.34-.455-.597-.552-.779-.139-.26-.16-.521.072-.594.04-.173.17-.35.427-.561-.207-.034-.328-.069-.434-.151a.391.391 0 01-.148-.221c-.177.021-.339.07-.516.145-.883.372-.442.197-.613.197-.1 0-.183-.008-.419-.038l-.04-.006c-.134-.016-.27-.019-.31-.066zm2.03.919c.003-.003.003-.007.003-.011zm.145-.212a.69.69 0 01.007 0z"
                />
              </g>
              <g mask="url(#mantine-jdoqnii0j)">
                <path stroke="#964c36" d="M1.655 6.11c-.318-.44-.477-.738-.477-.895" />
                <path
                  stroke="#2a8e51"
                  d="M1.359 5.543c-.407-.174-.61-.174-.61 0m.6-.274c-.286-.364-.537-.546-.752-.546s-.32.091-.315.273m.822-.274C.976 4.127.81 3.829.606 3.829c-.205 0-.307.149-.307.447m.882.444c-.056-.51.047-.765.31-.765"
                />
              </g>
              <g mask="url(#mantine-jdoqnii0j)">
                <path stroke="#964c36" d="M2.261 5.981c-.148-.522-.196-.857-.142-1.004" />
                <path
                  stroke="#2a8e51"
                  d="M2.177 5.347c-.323-.303-.514-.372-.573-.209m.657-.052c-.144-.44-.317-.697-.52-.77s-.331-.024-.389.149m.866.023c.084-.603.03-.94-.163-1.01-.192-.07-.339.036-.44.315m.676.72c.121-.499.306-.703.553-.613"
                />
              </g>
              <g strokeWidth=".7" mask="url(#mantine-jdoqnii0j)">
                <path stroke="#964c36" d="M2.752 6.26c.21-.5.299-.827.263-.98" />
                <path
                  stroke="#2a8e51"
                  d="M2.913 5.64c.357-.26.555-.306.594-.137m-.646-.132c.197-.418.4-.652.61-.7s.332.016.368.195m-.862-.082c-.01-.61.085-.936.284-.982.2-.046.332.076.4.366M2.9 4.8c-.058-.51-.216-.736-.473-.677"
                />
              </g>
              <g mask="url(#mantine-jdoqnii0j)">
                <g stroke="#2a8e51" strokeWidth=".7">
                  <path d="M6.698 5.802c.161-.742.472-1.114.93-1.114.46 0 .792.393.997 1.177" />
                  <path d="M6.13 5.042c.247-.439.778-.64 1.594-.604.816.036 1.298.237 1.447.604m-3.289-.837c.448-.555.986-.597 1.614-.127l.32.127c.213-.629.835-.629 1.866 0" />
                </g>
                <path stroke="#964c36" d="M7.738 6.037c.033-.693.105-1.134.214-1.325" />
              </g>
              <g mask="url(#mantine-jdoqnii0j)">
                <path
                  stroke="#964c36"
                  d="M9.099 8.314c-.412-.194-.68-.194-.803 0-.124.194-.928 1.181-2.413 2.962"
                />
                <path
                  fill="#fff203"
                  d="M6.964 8.595l1.381.965c.424-.302.53-.538.318-.709-.318-.256-1.184-.707-1.184-.707l-.515.451z"
                />
                <path
                  fill="#00a651"
                  d="M6.917 8.645c-.214.223-.32.42-.32.59 0 .256-.298.942-.298.942s.832.513 1.005.186c.173-.326 1.296-.13 1.098-.63-.132-.331-.627-.695-1.485-1.088z"
                />
              </g>
              <path
                fill="#ffd100"
                d="M1.056 1.182c.492-.252.86-.252 1.103 0 .365.379.664-.031.664-.26s.58-1.011.58-.375c0 .635-.181.994.328.994.51 0 2.803-.878 3.353-.618s.971.195.831-.178C7.775.373 7.416.14 6.725.343c-.693.204-.53.402-1.127.402S4.334.547 4.334.547s.187-.334.87-.097c.682.238 1.624-.294 1.88-.294S8.045.14 8.115.343c.07.204.496.39.171.58-.324.19-.86.308-.491.55s1.214.197 1.255.45c.041.252.442.63.281.63s-.452.355-.723.246-.303-.203-.043-.29c.26-.088.258-.457.043-.457s-.11.129-.597 0c-.488-.13-1.134-.273-1.095 0 .039.273.356.692-.23.747-.586.056-.86.28-.974.1-.114-.18-.522-.421-.202-.498.321-.077.627.262.743.207.115-.056.377-.087.158-.322-.22-.234-.58-.373-.246-.548.335-.176.071-.18-.567.184s-.994.674-1.555.63c-.56-.044-.77.015-.95-.044-.18-.059-1.058.652-1.31.472C1.53 2.8.714 2.73.86 2.508c.147-.222.344-.336.564-.222.22.115.437.229.586.115.148-.115.575-.507.468-.585-.108-.078-.004-.342-.613-.342s-.823.294-.968.109c-.096-.124-.043-.257.158-.4z"
                mask="url(#mantine-jdoqnii0j)"
              />
            </g>
          </g>
          <g mask="url(#mantine-m7n2k6bkv)">
            <use fill="#2b409a" xlinkHref="#mantine-2tyk1104e" />
            <g mask="url(#mantine-5h41yqe0m)">
              <g fillRule="nonzero">
                <path
                  fill="#f7fcff"
                  d="M-2.004 13l3.96 1.737L18.09 1.889l2.09-2.582-4.236-.58-6.58 5.536-5.297 3.73z"
                />
                <path fill="#f50100" d="M-1.462 14.217l2.018 1.008L19.429-.933h-2.833z" />
                <path
                  fill="#f7fcff"
                  d="M20.004 13l-3.96 1.737L-.09 1.889-2.18-.693l4.236-.58 6.58 5.536 5.297 3.73z"
                />
                <path
                  fill="#f50100"
                  d="M19.87 13.873l-2.019 1.008-8.036-6.917-2.383-.773L-2.38-.684H.453l9.807 7.688 2.605.926z"
                />
              </g>
              <path
                fill="#f50100"
                stroke="#f7fcff"
                strokeWidth="1.5"
                d="M10.735-.75v6h8.015v3.5h-8.016v6h-3.5v-6H-.75v-3.5h7.984v-6z"
              />
            </g>
          </g>
        </g>
      </svg>
    </Box>
  );
}
